module.exports = __webpack_public_path__ + "static/media/logo.7e535ae6.svg";